import { CloseButtonProps, MantineTheme, rem } from '@mantine/core';

export const DefaultCloseButtonProps = {
  size: 'md'
};

export const CloseButtonVarsResolver: (
  theme: MantineTheme,
  props: CloseButtonProps
) => any = (theme, props) => {
  const { size } = props;
  if (size === 'xs' || size === 'sm' || size === 'md') {
    return {
      root: {
        '--cb-size': rem(12)
      }
    };
  } else if (size === 'lg' || size == 'xl') {
    return {
      root: {
        '--cb-size': rem(16)
      }
    };
  }
};
